import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const checkStyle = {
  marginLeft: '-11px'
};
const styles = {
  label: {
    fontSize: 14,
    color: '#666'
  },
  hiddenLabel: {
    visibility: 'hidden'
  }
};
const CheckBoxContainer = ({ checkId, checked = false, onCheck, classes, hideLabel }) => {
  return (
    <div className="checkbox-container">
      <div className="checkbox-background" />
      <FormControlLabel
        style={checkStyle}
        classes={{
          label: hideLabel ? classes.hiddenLabel : classes.label
        }}
        control={<Checkbox checked={checked} onChange={onCheck} color={'primary'} />}
        label={checkId}
      />
    </div>
  );
};

CheckBoxContainer.propTypes = {
  checkId: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(CheckBoxContainer);
